var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner settlement-select-dialog",
      attrs: {
        no: "sendEmail",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SendEMail"),
        width: "950px",
        "append-to-body": _vm.appendToBody,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticClass: "app-main-inner-row",
          staticStyle: {
            "flex-direction": "column",
            "padding-bottom": "10px",
            "align-items": "center"
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-radio-group",
                {
                  attrs: { no: "customerType" },
                  on: {
                    change: function($event) {
                      return _vm.otherHandler()
                    }
                  },
                  model: {
                    value: _vm.customerType,
                    callback: function($$v) {
                      _vm.customerType = $$v
                    },
                    expression: "customerType"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Customer")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ShippingCmp")))
                  ]),
                  _c("el-radio", { attrs: { label: 3 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.BookingAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 4 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.LocalAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 5 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.UpDestAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 6 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))
                  ]),
                  _c("el-radio", { attrs: { label: 7 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Haulage")))
                  ]),
                  _c("el-radio", { attrs: { label: 8 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Warehouse")))
                  ]),
                  _c("el-radio", { attrs: { label: 9 } }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.EmailGroup")))
                  ]),
                  _c("el-radio", { attrs: { label: 10 } }, [
                    _vm._v(_vm._s(_vm.$t("Message.Shipper")))
                  ]),
                  _c("el-radio", { attrs: { label: 11 } }, [
                    _vm._v(_vm._s(_vm.$t("Message.Consignee")))
                  ]),
                  _c("el-radio", { attrs: { label: 12 } }, [
                    _vm._v(_vm._s(_vm.$t("Message.Notify")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticStyle: {
                width: "100%",
                margin: "0 auto",
                "padding-top": "5px"
              },
              attrs: { "label-width": "90px", "label-position": "left" }
            },
            [
              _vm.source === "7" &&
              _vm.job.sentDestinationPortAgentDate &&
              _vm.customerType === 5
                ? _c("el-form-item", [
                    _c("span", [
                      _c("i", {
                        staticClass: "el-icon-warning",
                        staticStyle: {
                          color: "#E6A23C",
                          "font-size": "14px",
                          "margin-right": "5px"
                        }
                      }),
                      _vm._v(
                        _vm._s(_vm.job.sentDestinationPortAgentDate) +
                          _vm._s(_vm.$t("Message.SentDestinationPortAgentTip"))
                      )
                    ])
                  ])
                : _vm._e(),
              !_vm.isEmailGroup
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CompanyName") } },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customerId",
                          "method-params":
                            ((_obj = {}),
                            (_obj[_vm.customerTypeName] = true),
                            _obj),
                          "default-value": _vm.customerId || ""
                        },
                        on: { change: _vm.customerIdChange }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isEmailGroup
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Receiver2") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "to",
                            filterable: true,
                            multiple: "",
                            "allow-create": ""
                          },
                          on: { clear: _vm.onClear, change: _vm.emailToChange },
                          model: {
                            value: _vm.emailToList,
                            callback: function($$v) {
                              _vm.emailToList = $$v
                            },
                            expression: "emailToList"
                          }
                        },
                        _vm._l(_vm.contactList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.uuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isEmailGroup
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long placeholder-margin",
                      attrs: { label: _vm.$t("SeaExport.Email") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "emailGroupTo",
                            filterable: true,
                            multiple: "",
                            clearable: true
                          },
                          on: {
                            clear: _vm.onClear,
                            change: _vm.emailGroupToChange
                          },
                          model: {
                            value: _vm.emailGroupTo,
                            callback: function($$v) {
                              _vm.emailGroupTo = $$v
                            },
                            expression: "emailGroupTo"
                          }
                        },
                        _vm._l(_vm.emailGroupToList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.groupName, value: item.uuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.emailGroup
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long placeholder-margin",
                      attrs: {
                        label:
                          _vm.$t("SeaExport.Cc") +
                          _vm.$t("SeaExport.EmailGroup")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "emailGroupCc",
                            filterable: true,
                            multiple: "",
                            clearable: true
                          },
                          on: {
                            clear: _vm.onClearCc,
                            change: _vm.emailGroupCcChange
                          },
                          model: {
                            value: _vm.emailGroupCc,
                            callback: function($$v) {
                              _vm.emailGroupCc = $$v
                            },
                            expression: "emailGroupCc"
                          }
                        },
                        _vm._l(_vm.emailGroupCcList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.groupName, value: item.uuid }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Cc") } },
                [
                  _c("el-input", {
                    attrs: { no: "cc", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.emailForm.cc,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "cc", $$v)
                      },
                      expression: "emailForm.cc"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "sales" },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("sales", _vm.sales)
                        }
                      },
                      model: {
                        value: _vm.sales,
                        callback: function($$v) {
                          _vm.sales = $$v
                        },
                        expression: "sales"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "op" },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("op", _vm.op)
                        }
                      },
                      model: {
                        value: _vm.op,
                        callback: function($$v) {
                          _vm.op = $$v
                        },
                        expression: "op"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "csr" },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("csr", _vm.csr)
                        }
                      },
                      model: {
                        value: _vm.csr,
                        callback: function($$v) {
                          _vm.csr = $$v
                        },
                        expression: "csr"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerService")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "doc" },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler("dc", _vm.doc)
                        }
                      },
                      model: {
                        value: _vm.doc,
                        callback: function($$v) {
                          _vm.doc = $$v
                        },
                        expression: "doc"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Documents")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "emailGroup" },
                      on: {
                        change: function($event) {
                          return _vm.ccChangeHandler(
                            "emailGroup",
                            _vm.emailGroup
                          )
                        }
                      },
                      model: {
                        value: _vm.emailGroup,
                        callback: function($$v) {
                          _vm.emailGroup = $$v
                        },
                        expression: "emailGroup"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.EmailGroup")))]
                  ),
                  _vm.isSeBooking
                    ? [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "siteOP" },
                            on: {
                              change: function($event) {
                                return _vm.ccChangeHandler("siteOP", _vm.siteOP)
                              }
                            },
                            model: {
                              value: _vm.siteOP,
                              callback: function($$v) {
                                _vm.siteOP = $$v
                              },
                              expression: "siteOP"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.FieldOperation")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "overseaOp" },
                            on: {
                              change: function($event) {
                                return _vm.ccChangeHandler(
                                  "overseaOp",
                                  _vm.overseaOp
                                )
                              }
                            },
                            model: {
                              value: _vm.overseaOp,
                              callback: function($$v) {
                                _vm.overseaOp = $$v
                              },
                              expression: "overseaOp"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.OverseaCustomerService"))
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "planner" },
                            on: {
                              change: function($event) {
                                return _vm.ccChangeHandler(
                                  "planner",
                                  _vm.planner
                                )
                              }
                            },
                            model: {
                              value: _vm.planner,
                              callback: function($$v) {
                                _vm.planner = $$v
                              },
                              expression: "planner"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AirlinePerson2")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "userDefinedRoleId1" },
                            on: {
                              change: function($event) {
                                return _vm.ccChangeHandler(
                                  "userDefinedRoleId1",
                                  _vm.userDefinedRoleId1
                                )
                              }
                            },
                            model: {
                              value: _vm.userDefinedRoleId1,
                              callback: function($$v) {
                                _vm.userDefinedRoleId1 = $$v
                              },
                              expression: "userDefinedRoleId1"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_userDefinedRole1"))
                            )
                          ]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "userDefinedRoleId2" },
                            on: {
                              change: function($event) {
                                return _vm.ccChangeHandler(
                                  "userDefinedRoleId2",
                                  _vm.userDefinedRoleId2
                                )
                              }
                            },
                            model: {
                              value: _vm.userDefinedRoleId2,
                              callback: function($$v) {
                                _vm.userDefinedRoleId2 = $$v
                              },
                              expression: "userDefinedRoleId2"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_userDefinedRole2"))
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "defaultCc" },
                      model: {
                        value: _vm.defaultCc,
                        callback: function($$v) {
                          _vm.defaultCc = $$v
                        },
                        expression: "defaultCc"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.SaveTheDefaultCC")))]
                  )
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.mailTemplate") } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "margin-bottom": "8px" }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { no: "emailTemplate" },
                        on: { change: _vm.emailTemplateCheck },
                        model: {
                          value: _vm.emailTemplate,
                          callback: function($$v) {
                            _vm.emailTemplate = $$v
                          },
                          expression: "emailTemplate"
                        }
                      }),
                      _c(
                        "span",
                        { staticStyle: { flex: "1", "margin-left": "10px" } },
                        [
                          _c("cargo-combo-box", {
                            attrs: {
                              no: "themeTemplate",
                              disabled: !_vm.emailTemplate,
                              "allow-create": true,
                              clearable: true,
                              options: _vm.emailTemplateList,
                              "label-function": _vm.titleLabelFunction,
                              "placeholder-val": _vm.$t(
                                "SeaExport.placeholderVal"
                              ),
                              "value-field": "uuid",
                              "forbid-values": [""]
                            },
                            on: {
                              change: _vm.emailTemplateChange,
                              clear: _vm.onClearTitle
                            },
                            model: {
                              value: _vm.themeTemplate,
                              callback: function($$v) {
                                _vm.themeTemplate = $$v
                              },
                              expression: "themeTemplate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.emailSubject") } },
                [
                  _c(
                    "span",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: { no: "title" },
                        model: {
                          value: _vm.emailForm.title,
                          callback: function($$v) {
                            _vm.$set(_vm.emailForm, "title", $$v)
                          },
                          expression: "emailForm.title"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.source === "7" || _vm.source === "4",
                      expression: "source === '7' || source === '4'"
                    }
                  ],
                  staticStyle: { height: "auto" },
                  attrs: { label: _vm.$t("SeaExport.MailContent") }
                },
                [
                  _c("quill-editor", {
                    staticClass: "my-custom-quill-editor-send-email",
                    staticStyle: { height: "auto" },
                    attrs: { no: "mailContent", options: _vm.editorOption },
                    model: {
                      value: _vm.emailForm.mailContent,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "mailContent", $$v)
                      },
                      expression: "emailForm.mailContent"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.source !== "7" && _vm.source !== "4",
                      expression: "source !== '7' && source !== '4'"
                    }
                  ],
                  attrs: { label: _vm.$t("SeaExport.MailContent") }
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showContent,
                        expression: "showContent"
                      }
                    ],
                    attrs: { no: "content", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.emailForm.content,
                      callback: function($$v) {
                        _vm.$set(_vm.emailForm, "content", $$v)
                      },
                      expression: "emailForm.content"
                    }
                  }),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showContent,
                        expression: "!showContent"
                      }
                    ],
                    attrs: { no: "tempStr", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.tempStr,
                      callback: function($$v) {
                        _vm.tempStr = $$v
                      },
                      expression: "tempStr"
                    }
                  })
                ],
                1
              ),
              _vm.source === "7" || _vm.source === "4"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long",
                      attrs: { label: _vm.$t("SeaExport.SendEMail") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "mailType",
                            placeholder: _vm.$t("SeaExport.SystemEmail")
                          },
                          model: {
                            value: _vm.emailForm.mailType,
                            callback: function($$v) {
                              _vm.$set(_vm.emailForm, "mailType", $$v)
                            },
                            expression: "emailForm.mailType"
                          }
                        },
                        _vm._l(_vm.sendEmailList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.source === "4"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "long",
                      attrs: { label: _vm.$t("SeaExport.attachment") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            attrs: { no: "templateName", clearable: "" },
                            on: { input: _vm.paste },
                            model: {
                              value: _vm.templateName,
                              callback: function($$v) {
                                _vm.templateName = $$v
                              },
                              expression: "templateName"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.source === "4",
                  expression: "source === '4'"
                }
              ],
              attrs: { no: "preview", type: "primary", plain: "" },
              on: { click: _vm.sendMailPreview }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.preview")))]
          ),
          _c(
            "el-button",
            {
              attrs: {
                no: "invokeLocalMailClient",
                type: "primary",
                plain: ""
              },
              on: { click: _vm.localEmailClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.InvokeLocalMailClient")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.okClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Send")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }